export const BENEFIT_ID_MOCK = 'benefit-id-mock';
